import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-tous-cmd-fourn',
  templateUrl: './tous-cmd-fourn.component.html',
  styleUrls: ['./tous-cmd-fourn.component.scss']
})
export class TousCmdFournComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('TousCmdComponent initialized');
        this.dataService.filterOrdersByStatus('Tous');
    }

}
